import React, { useState } from 'react';
import {
    Menu,
    MenuItem,
    IconButton,
    Box,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const ThreeDotMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>
            <IconButton
                onClick={handleClick}
                sx={{ 
                    color: 'text.primary',
                    padding: '8px',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <MoreHorizIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 3,
                    sx: {
                        width: 200,
                        mt: 1.5,
                        padding: 1,
                        borderRadius: 2,
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleClose} component="a" href="/faq">
                    FAQ
                </MenuItem>
                <MenuItem onClick={handleClose} component="a" href="/blog">
                    Blog
                </MenuItem>
                <MenuItem onClick={handleClose} component="a" href="/terms">
                    Terms
                </MenuItem>
                <MenuItem onClick={handleClose} component="a" href="/privacy">
                    Privacy
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default ThreeDotMenu; 